/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeSellbotSkullTextureDto,
  SellbotSkullTextureUploadBody
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type sellbotSkullTextureUploadResponse200 = {
  data: ApiEnvelopeSellbotSkullTextureDto
  status: 200
}

export type sellbotSkullTextureUploadResponse400 = {
  data: ApiEnvelopeSellbotSkullTextureDto
  status: 400
}

export type sellbotSkullTextureUploadResponseSuccess = (sellbotSkullTextureUploadResponse200) & {
  headers: Headers;
};
export type sellbotSkullTextureUploadResponseError = (sellbotSkullTextureUploadResponse400) & {
  headers: Headers;
};

export type sellbotSkullTextureUploadResponse = (sellbotSkullTextureUploadResponseSuccess | sellbotSkullTextureUploadResponseError)

export const getSellbotSkullTextureUploadUrl = () => {




  return `/api/sellbot/skull-texture`
}

export const useSellbotSkullTextureUploadHook = (): (sellbotSkullTextureUploadBody?: SellbotSkullTextureUploadBody, options?: RequestInit) => Promise<sellbotSkullTextureUploadResponse> => {

      const customFetcher = useSfetchMutator();
      return (sellbotSkullTextureUploadBody?: SellbotSkullTextureUploadBody, options?: RequestInit) => {
        const formData = new FormData();
if(sellbotSkullTextureUploadBody?.file !== undefined) {
 formData.append(`file`, sellbotSkullTextureUploadBody.file);
 }

        return customFetcher(getSellbotSkullTextureUploadUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);
      }
  }


export type sellbotSkullTextureGetResponse200 = {
  data: Blob
  status: 200
}

export type sellbotSkullTextureGetResponse404 = {
  data: Blob
  status: 404
}

export type sellbotSkullTextureGetResponseSuccess = (sellbotSkullTextureGetResponse200) & {
  headers: Headers;
};
export type sellbotSkullTextureGetResponseError = (sellbotSkullTextureGetResponse404) & {
  headers: Headers;
};

export type sellbotSkullTextureGetResponse = (sellbotSkullTextureGetResponseSuccess | sellbotSkullTextureGetResponseError)

export const getSellbotSkullTextureGetUrl = (hash: string,) => {




  return `/api/sellbot/skull-texture/${hash}.png`
}

export const useSellbotSkullTextureGetHook = (): (hash: string, options?: RequestInit) => Promise<sellbotSkullTextureGetResponse> => {

      const customFetcher = useSfetchMutator();
      return (hash: string, options?: RequestInit) => {

        return customFetcher(getSellbotSkullTextureGetUrl(hash),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


